import { useUserPilotReload } from 'hooks/useUserPilot';

interface UserPilotReloadProps {
  isAuthenticated: boolean;
}

export const UserPilotReload = ({ isAuthenticated }: UserPilotReloadProps) => {
  useUserPilotReload(isAuthenticated);

  return null;
};
